import KDTree from './KDTree';
// @ts-ignore
import ObjectArrayView from './ObjectArrayView';
import ObjectsByName from './ObjectsByName';

export default { KDTree, ObjectArrayView, ObjectsByName };
